export default "__VITE_ASSET__Bz_Z1J0Y__"